import { createSelector } from 'reselect';
import { alignLeftCellStyle, alignRightCellStyle, alignCenterCellStyle } from '@common/cellStyles';
import { valueGetter, isGroupReportCellEditable, findEditableDataForGroupReport } from '../gridReport/columns/helpers';
import { gridNumeralCellDefinition, gridTextCellDefinition } from '../gridReport/columns/baseDefinitions';

const getColumnDefinitions = editableColumns => [
  {
    headerName: '',
    valueGetter: valueGetter('taxYear'),
    ...gridTextCellDefinition,
    minWidth: 50,
    width: 50,
    ...alignCenterCellStyle,
  },
  {
    headerName: '',
    valueGetter: valueGetter('description'),
    ...gridTextCellDefinition,
    minWidth: 200,
    width: 200,
    ...alignLeftCellStyle,
  },
  {
    headerName: 'Opening',
    valueGetter: valueGetter('OPEN', { affectedTotals: ['END'] }),
    editable: isGroupReportCellEditable('OPEN', editableColumns),
    cellEditorParams: findEditableDataForGroupReport('OPEN', editableColumns),
    ...gridNumeralCellDefinition,
    ...alignRightCellStyle,
  },
  {
    headerName: 'FX',
    valueGetter: valueGetter('FX', { affectedTotals: ['END'] }),
    editable: isGroupReportCellEditable('FX', editableColumns),
    cellEditorParams: findEditableDataForGroupReport('FX', editableColumns),
    ...gridNumeralCellDefinition,
    ...alignRightCellStyle,
  },
  {
    headerName: 'P&L',
    valueGetter: valueGetter('PL', { affectedTotals: ['END'] }),
    editable: isGroupReportCellEditable('PL', editableColumns),
    cellEditorParams: findEditableDataForGroupReport('PL', editableColumns),
    ...gridNumeralCellDefinition,
    ...alignRightCellStyle,
  },
  {
    headerName: 'BS',
    valueGetter: valueGetter('BS', { affectedTotals: ['END'] }),
    editable: isGroupReportCellEditable('BS', editableColumns),
    cellEditorParams: findEditableDataForGroupReport('BS', editableColumns),
    ...gridNumeralCellDefinition,
    ...alignRightCellStyle,
  },
  {
    headerName: 'Payments',
    valueGetter: valueGetter('PYMT', { affectedTotals: ['END'] }),
    editable: isGroupReportCellEditable('PYMT', editableColumns),
    cellEditorParams: findEditableDataForGroupReport('PYMT', editableColumns),
    ...gridNumeralCellDefinition,
    ...alignRightCellStyle,
  },
  {
    headerName: 'Transfers',
    valueGetter: valueGetter('TRAN', { affectedTotals: ['END'] }),
    editable: isGroupReportCellEditable('TRAN', editableColumns),
    cellEditorParams: findEditableDataForGroupReport('TRAN', editableColumns),
    ...gridNumeralCellDefinition,
    ...alignRightCellStyle,
  },
  {
    headerName: 'Other',
    valueGetter: valueGetter('OTH', { affectedTotals: ['END'] }),
    editable: isGroupReportCellEditable('OTH', editableColumns),
    cellEditorParams: findEditableDataForGroupReport('OTH', editableColumns),
    ...gridNumeralCellDefinition,
    ...alignRightCellStyle,
  },
  {
    headerName: 'Ending',
    valueGetter: valueGetter('END'),
    editable: isGroupReportCellEditable('END', editableColumns),
    cellEditorParams: findEditableDataForGroupReport('END', editableColumns),
    ...gridNumeralCellDefinition,
    ...alignRightCellStyle,
  },
];

export default createSelector(
  (reportData, isAllowedToMakeDirectEntries, isClientLocked) =>
    (isAllowedToMakeDirectEntries && !isClientLocked && reportData) ? reportData.editableColumns : [],
  editableColumns => getColumnDefinitions(editableColumns)
);
